import React from 'react';

const Notification = ({text, icon}) => {
    return (
        <div className={`notification flex flex-align-center`}>
            <div className="notification-icon">
                <i className={`icon-${icon}`} />
            </div>
            <div className="notification-text small-text">{text}</div>
        </div>
    );
}

export default Notification;
